import Template from './SettingsView.njk';
import Marionette from "backbone.marionette";
import { DisplayCollection } from "../../../collections/DisplayCollection";
import { DisplayCollectionView } from "../../components/DisplayCollectionView";

export const SettingsView = Marionette.View.extend({
  template: Template,
    regions: {
        displayList: ".region-display-list"
    },

    onRender() {
        var displayCollection = new DisplayCollection();
        displayCollection.fetch({
            data: {seller: this.model.id},
            success: () => {
                displayCollection.fetched = true;
            }
        });

        var view = new DisplayCollectionView({collection: displayCollection});

        this.showChildView("displayList", view);
    }
});




// WEBPACK FOOTER //
// ./src/js/view/pages/settings/SettingsView.js